import { message } from "antd";
import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { GetShowById } from "../../services/shows";
import { HideLoading, ShowLoading } from "../../redux/loadersSlice";
import StripeCheckout from "react-stripe-checkout";
import Button from "../../components/Button";
import { BookShowTickets, MakePayment } from "../../services/bookings";

function BookShow() {
    const { user } = useSelector((state) => state.users);
    const [show, setShow] = React.useState(null);
    const [selectedSeats, setSelectedSeats] = React.useState([]);
    const params = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const getData = async () => {
        try {
            dispatch(ShowLoading());
            const response = await GetShowById(params.id);
            if (response.success) {
                setShow(response.data);
            } else {
                message.error(response.message);
            }
            dispatch(HideLoading());
        } catch (error) {
            dispatch(HideLoading());
            message.error(error.message);
        }
    };

    const getSeats = () => {
        const columns = 12;
        const totalSeats = show.totalSeats;
        const rows = Math.ceil(totalSeats / columns);

        return (
            <div className="card gap-1 row-display flex-column p-2 ">
                {Array.from(Array(rows).keys()).map((seat, index) => {
                    return (
                        <div className="flex gap-1 justify-center">
                            {Array.from(Array(columns).keys()).map((column, index) => {
                                // return (
                                //     <div className="seat">
                                //         <h1 className="text-sm">{seat * columns + column + 1}</h1>
                                //
                                //     </div>
                                // );
                                const seatNumber = seat * columns + column + 1;
                                let seatClass = "seat";

                                if (selectedSeats.includes(seat * columns + column + 1)) {
                                    seatClass = seatClass + " selected-seat";
                                }

                                if (show.bookedSeats.includes(seat * columns + column + 1)) {
                                    seatClass = seatClass + " booked-seat";
                                }

                                return (
                                    seat * columns + column + 1 <= totalSeats && (
                                        <div
                                            className={seatClass}
                                            onClick={() => {
                                                if (selectedSeats.includes(seatNumber)) {
                                                    setSelectedSeats(
                                                        selectedSeats.filter((item) => item !== seatNumber)
                                                    );
                                                } else {
                                                    setSelectedSeats([...selectedSeats, seatNumber]);
                                                }
                                            }}
                                        >
                                            <h1 className="text-sm">{seat * columns + column + 1}</h1>
                                        </div>
                                    )
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        );
    };

    const onToken = async (token) => {
        try {
            dispatch(ShowLoading());
            const response = await MakePayment(
                token,
                selectedSeats.length * show.ticketPrice * 100
            );
            if (response.success) {
                message.success(response.message);
                book(response.data);
            } else {
                message.error(response.message);
            }
            dispatch(HideLoading());
        } catch (error) {
            message.error(error.message);
            dispatch(HideLoading());
        }
    };

    const book = async (transactionId) => {
        try {
            dispatch(ShowLoading());
            const response = await BookShowTickets({
                show: params.id,
                seats: selectedSeats,
                transactionId,
                user: user._id,
            });
            if (response.success) {
                message.success(response.message);
                navigate("/movie");
            } else {
                message.error(response.message);
            }
            dispatch(HideLoading());
        } catch (error) {
            message.error(error.message);
            dispatch(HideLoading());
        }
    };


    useEffect(() => {
        getData();
    }, []);

    return (
        show && (
            <div>
                {/* show infomation */}

                <div className="flex justify-between card p-2 items-center">
                    <div>
                        <h1 className="text-xl">{show.theatre.name}</h1>
                        <h1 className="text-sm">{show.theatre.address}</h1>
                    </div>

                    <div>
                        <h1 className="text-2xl uppercase">
                            {show.movie.title} ({show.movie.language})
                        </h1>
                    </div>

                    <div>
                        <h1 className="text-sm">
                            {moment(show.date).format("MMM Do yyyy")} -{" "}
                            {moment(show.time, "HH:mm").format("hh:mm A")}
                        </h1>
                    </div>
                </div>

                {/* seats */}

                <div className="justify-center mt-2">{getSeats()}</div>

                {selectedSeats.length > 0 && (
                    <div className="mt-2 flex justify-center gap-2 items-center flex-col">
                        <div className="flex justify-center">
                            <div className="flex uppercase card p-2 gap-3">
                                <h1 className="text-sm"><b>Selected Seats</b> : {selectedSeats.join(" , ")}</h1>

                                <h1 className="text-sm">
                                    <b>Total Price</b> : {selectedSeats.length * show.ticketPrice}
                                </h1>
                            </div>
                        </div>
                        <StripeCheckout
                            token={onToken}
                            amount={selectedSeats.length * show.ticketPrice * 100}
                            billingAddress
                            stripeKey="pk_test_51LPxsHB9TxsNRZBa1zNcXxXNyrJ8SUcG9NNdCZaxZpteqGsonx9flhRjvS8gTpRsPMwf51doxqeyI1ffCKBoXFOP00H2W65rjL"
                        >
                            <Button title="Book Now" />
                        </StripeCheckout>
                    </div>
                )}
            </div>
        )
  );
}

export default BookShow;
